import React from "react";
import { Route, Switch } from "react-router-dom";
import routes from "../../config/routes";
import { useUser } from '../../hooks';

import Login from '../../pages/login';
import NotFoundPage from '../../pages/404';

export default function AppRoute() {
  const { isUserLoggedIn } = useUser();

  return (
    <Switch>
      {routes.map(route => {
        const Component = route.component;
        
        if (route.exact) {
          return (
            <Route
              exact path={route.path}
              key={route.key}
              isPrivate={route.isPrivate}
              render={props => (
                route.isPrivate && !isUserLoggedIn 
                ?<Login />
                : <Component {...props}/> 
              )}
            />
          );
        }

        return <Route
          path={route.path}
          key={route.path}
          isPrivate={route.isPrivate}
          render={props => (
            route.isPrivate && !isUserLoggedIn
            ?<Login />
            : <Component {...props}/> 
          )}
        />
        }

      )}
      
      <Route render={props => <NotFoundPage {...props}/>} />
    </Switch>
  );
}

